module.exports = __webpack_public_path__ + "img/status-2.684bf8cc.svg";